export default function WebhookLogs( { logs, onClear } ) {
	if ( ! logs.length ) {
		return (
			<div className="rtwc-section">
				<p className="description rtwc-section-desc">Last 10 webhook executions are recorded here.</p>
				<div className="rtwc-empty-table">
					<em>No logs yet. Logs appear after the webhook is triggered by a form submission.</em>
				</div>
			</div>
		);
	}

	return (
		<div className="rtwc-section">
			<div className="rtwc-logs-header">
				<p className="description rtwc-section-desc">
					Last { logs.length } webhook execution{ logs.length !== 1 ? 's' : '' } — newest first.
				</p>
				<button className="button button-small rtwc-clear-btn" onClick={ onClear }>
					Clear Logs
				</button>
			</div>

			<div className="rtwc-log-cards">
				{ logs.map( ( log, i ) => {
					const status = log.response_status;
					const isOk   = String( status ).startsWith( '2' );

					return (
						<div key={ i } className={ `rtwc-log-card ${ isOk ? 'rtwc-log-card--ok' : 'rtwc-log-card--err' }` }>

							{/* ── Card header ── */}
							<div className="rtwc-log-card-header">
								<div className="rtwc-log-card-meta">
									<span className={ `rtwc-badge rtwc-badge--${ ( log.request_method || 'POST' ).toLowerCase() }` }>
										{ log.request_method || 'POST' }
									</span>
									<span className={ `rtwc-status-code ${ isOk ? 'rtwc-status-code--ok' : 'rtwc-status-code--err' }` }>
										{ isOk ? '✓' : '✗' } { status || 'N/A' }
									</span>
									<span className="rtwc-log-time">{ formatTime( log.time ) }</span>
								</div>
								<code className="rtwc-log-url" title={ log.request_url }>
									{ log.request_url || '—' }
								</code>
							</div>

							{/* ── Card body: two columns ── */}
							<div className="rtwc-log-card-body">

								{/* Left: Request */}
								<div className="rtwc-log-panel">
									<div className="rtwc-log-panel-title rtwc-log-panel-title--req">
										↑ Request
									</div>

									{ log.request_headers && Object.keys( log.request_headers ).length > 0 && (
										<div className="rtwc-log-block">
											<span className="rtwc-log-block-label">Headers</span>
											<pre className="rtwc-log-pre">{ JSON.stringify( log.request_headers, null, 2 ) }</pre>
										</div>
									) }

									<div className="rtwc-log-block">
										<span className="rtwc-log-block-label">Body</span>
										<pre className="rtwc-log-pre">
											{ log.request_body
												? prettyJson( log.request_body )
												: <em className="rtwc-log-empty">No body (GET request)</em>
											}
										</pre>
									</div>
								</div>

								{/* Right: Response */}
								<div className="rtwc-log-panel">
									<div className={ `rtwc-log-panel-title ${ isOk ? 'rtwc-log-panel-title--ok' : 'rtwc-log-panel-title--err' }` }>
										↓ Response &nbsp;
										<span className={ `rtwc-status-code ${ isOk ? 'rtwc-status-code--ok' : 'rtwc-status-code--err' }` }>
											{ status || 'N/A' }
										</span>
									</div>

									<div className="rtwc-log-block">
										<span className="rtwc-log-block-label">Body</span>
										<pre className="rtwc-log-pre">
											{ log.response_message
												? prettyJson( log.response_message )
												: <em className="rtwc-log-empty">Empty response</em>
											}
										</pre>
									</div>
								</div>

							</div>
						</div>
					);
				} ) }
			</div>
		</div>
	);
}

function formatTime( ts ) {
	if ( ! ts ) return 'N/A';
	return new Date( ts * 1000 ).toLocaleString();
}

function prettyJson( str ) {
	try {
		return JSON.stringify( JSON.parse( str ), null, 2 );
	} catch {
		return str;
	}
}
